export const AllRoutes = {
    'rootRoute': {
        'path': '/',
        'redirect': 'login'
    },
    'loginRoute': {
        'path': '/login',
        'name': 'login',
        'meta': {
            'withoutPageWrapper': true,
            'title': 'Login'
        },
        'component': (resolve) => {
            require(['@/views/account/login'], resolve);
        }
    },
    'registerUserRoute': {
        'path': '/register',
        'name': 'register',
        'meta': {
            'title': 'Register User',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/register'], resolve);
        }
    },
    'changePasswordRoute': {
        'path': '/change-password',
        'name': 'change-password',
        'meta': {
            'title': 'Change Password',
            'icon': 'fa-lock'
        },
        'component': (resolve) => {
            require(['@/views/account/change-password'], resolve);
        }
    },
    'forgotPasswordRoute': {
        'path': '/forgot-password',
        'name': 'forgot-password',
        'meta': {
            'title': 'Forgot Password',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/forgot-password'], resolve);
        }
    },
    'updateEmailAddressRoute': {
        'path': '/update-email-address',
        'name': 'update-email-address',
        'meta': {
            'title': 'Update E-mail Address'
        },
        'component': (resolve) => {
            require(['@/views/account/update-email-address'], resolve);
        }
    },
    'verifyEmailAddressRoute': {
        'path': '/verify-email',
        'name': 'verify-email',
        'meta': {
            'title': 'Verify E-mail Address',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/verify-email'], resolve);
        }
    },
    'userDashboardRoute': {
        'path': '/user/dashboard',
        'name': 'dashboard-user',
        'meta': {
            'title': 'Dashboard',
            'icon': 'fa-chart-pie'
        },
        'component': (resolve) => {
            require(['@/views/dashboard/user'], resolve);
        }
    },
    'doctorDashboardRoute': {
        'path': '/doctor/dashboard',
        'name': 'dashboard-doctor',
        'meta': {
            'title': 'Dashboard',
            'icon': 'fa-chart-pie'
        },
        'component': (resolve) => {
            require(['@/views/dashboard/doctor'], resolve);
        }
    },
    'pharmacyDashboardRoute': {
        'path': '/pharmacy/dashboard',
        'name': 'dashboard-pharmacy',
        'meta': {
            'title': 'Dashboard',
            'icon': 'fa-chart-pie'
        },
        'component': (resolve) => {
            require(['@/views/dashboard/pharmacy'], resolve);
        }
    },
    'adminDashboardRoute': {
        'path': '/admin/dashboard',
        'name': 'dashboard-admin',
        'meta': {
            'title': 'Dashboard',
            'icon': 'fa-chart-pie'
        },
        'component': (resolve) => {
            require(['@/views/dashboard/admin'], resolve);
        }
    },
    'companyDashboardRoute': {
        'path': '/company/dashboard',
        'name': 'dashboard-company',
        'meta': {
            'title': 'Dashboard',
            'icon': 'fa-chart-pie'
        },
        'component': (resolve) => {
            require(['@/views/dashboard/company'], resolve);
        }
    },
    'userAddConsultationRoute': {
        'path': '/user/doctor-appointment/create',
        'name': 'user-doctor-appointment-create',
        'meta': {
            'title': 'Book Consultation',
            'icon': 'fa-notes-medical'
        },
        'component': (resolve) => {
            require(['@/views/appointments/user/doctor/add'], resolve);
        }
    },
    'userDoctorAppointmentListRoute': {
        'path': '/user/doctor-appointment',
        'name': 'user-doctor-appointments',
        'meta': {
            'title': 'Upcoming Consultations',
            'icon': 'fa-calendar-check'
        },
        'component': (resolve) => {
            require(['@/views/appointments/user/doctor/list'], resolve);
        }
    },
    'userDoctorAppointmentDetailRoute': {
        'path': '/user/doctor-appointment/detail/:id',
        'name': 'user-doctor-appointment-detail',
        'meta': {
            'title': 'Doctor Appointment Detail'
        },
        'component': (resolve) => {
            require(['@/views/appointments/user/doctor/detail'], resolve);
        }
    },
    'userConsultationDetailRoute': {
        'path': '/user/consultation/detail/:id',
        'name': 'user-consultation-detail',
        'meta': {
            'title': 'Consultation Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation/user/detail'], resolve);
        }
    },
    'userClinicConsultationDetailRoute': {
        'path': '/user/clinic-consultation/detail/:id',
        'name': 'user-clinic-consultation-detail',
        'meta': {
            'title': 'Consultation Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation/clinic/detail'], resolve);
        }
    },
    'userConsultationDoneRoute': {
        'path': '/user/doctor-appointment/thank-you',
        'name': 'user-doctor-appointment-done',
        'meta': {
            'title': 'Thank You'
        },
        'component': (resolve) => {
            require(['@/views/consultation/user/thank-you'], resolve);
        }
    },
    'userDoctorConsultationHistoryListRoute': {
        'path': '/user/doctor-consultation/list',
        'name': 'user-doctor-consultation-list',
        'meta': {
            'title': 'Telemedicine Consultations',
            'icon': 'fa-history'
        },
        'component': (resolve) => {
            require(['@/views/consultation/user/list'], resolve);
        }
    },
    'userClinicConsultationHistoryListRoute': {
        'path': '/user/clinic-consultation/list',
        'name': 'user-clinic-consultation-list',
        'meta': {
            'title': 'Clinic Consultations',
            'icon': 'fa-history'
        },
        'component': (resolve) => {
            require(['@/views/consultation/clinic/list'], resolve);
        }
    },
    'doctorCalendarRoute': {
        'path': '/doctor/calendar',
        'name': 'doctor-calendar',
        'meta': {
            'title': 'My Calendar',
            'icon': 'fa-calendar-alt'
        },
        'component': (resolve) => {
            require(['@/views/calendar/doctor/'], resolve);
        }
    },
    'doctorAppointmentListRoute': {
        'path': '/doctor/consultation',
        'name': 'doctor-consultation-list',
        'meta': {
            'title': 'Patient Appointments',
            'icon': 'fa-calendar-check'
        },
        'component': (resolve) => {
            require(['@/views/consultation/doctor/list'], resolve);
        }
    },
    'doctorAppointmentRequestsRoute': {
        'path': '/doctor/appointment-requests',
        'name': 'doctor-appointment-requests',
        'meta': {
            'title': 'Appointment Requests',
            'icon': 'fa-concierge-bell'
        },
        'component': (resolve) => {
            require(['@/views/appointments/doctor/requests'], resolve);
        }
    },
    'doctorAppointmentDetailRoute': {
        'path': '/doctor/appointment-requests/detail/:id',
        'name': 'doctor-appointment-detail',
        'meta': {
            'title': 'Appointment Details'
        },
        'component': (resolve) => {
            require(['@/views/appointments/doctor/detail'], resolve);
        }
    },
    'doctorConsultationDetailRoute': {
        'path': '/doctor/consultation/detail/:id',
        'name': 'doctor-consultation-detail',
        'meta': {
            'title': 'Consultation Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation/doctor/detail'], resolve);
        }
    },
    'doctorConsultationDetailNoPharmacyRoute': {
        'path': '/doctor/consultation-type-2/detail/:id',
        'name': 'doctor-consultation-no-pharmacy-detail',
        'meta': {
            'title': 'Consultation Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation/doctor/detail-no-pharmacy'], resolve);
        }
    },
    'profileCompanyRoute': {
        'path': '/company/profile',
        'name': 'company-profile',
        'meta': {
            'title': 'Company Profile',
            'icon': 'fa-building'
        },
        'component': (resolve) => {
            require(['@/views/profile/company'], resolve);
        }
    },
    'profilePharmacyRoute': {
        'path': '/pharmacy/profile',
        'name': 'pharmacy-profile',
        'meta': {
            'title': 'Pharmacy Profile',
            'icon': 'fa-hospital'
        },
        'component': (resolve) => {
            require(['@/views/profile/pharmacy'], resolve);
        }
    },
    'profilePharmacyUserRoute': {
        'path': '/pharmacy/user/profile',
        'name': 'pharmacy-user-profile',
        'meta': {
            'title': 'My Profile',
            'icon': 'fa-user'
        },
        'component': (resolve) => {
            require(['@/views/profile/pharmacy-user'], resolve);
        }
    },
    'profileDoctorRoute': {
        'path': '/doctor/profile',
        'name': 'doctor-profile',
        'meta': {
            'title': 'My Profile',
            'icon': 'fa-user-md'
        },
        'component': (resolve) => {
            require(['@/views/profile/doctor'], resolve);
        }
    },
    'profileClinicRoute': {
        'path': '/clinic/profile',
        'name': 'clinic-profile',
        'meta': {
            'title': 'Clinic Profile',
            'icon': 'fa-user'
        },
        'component': (resolve) => {
            require(['@/views/profile/clinic'], resolve);
        }
    },
    'profileOptometristRoute': {
        'path': '/optometrist/profile',
        'name': 'optometrist-profile',
        'meta': {
            'title': 'Practice Profile',
            'icon': 'fa-user'
        },
        'component': (resolve) => {
            require(['@/views/profile/optometrist'], resolve);
        }
    },
    'profileUserRoute': {
        'path': '/user/profile',
        'name': 'user-profile',
        'meta': {
            'title': 'Profile',
            'icon': 'fa-user'
        },
        'component': (resolve) => {
            require(['@/views/profile/user'], resolve);
        }
    },
    'systemSettingRoute': {
        'path': '/settings',
        'name': 'system-settings',
        'meta': {
            'title': 'System Settings',
            'icon': 'fa-cog'
        },
        'component': (resolve) => {
            require(['@/views/settings'], resolve);
        }
    },
    'viewCompanyUserRoute': {
        'path': '/company/users',
        'name': 'view-company-users',
        'meta': {
            'title': 'View Company Employees',
            'icon': 'fa-users'
        },
        'component': (resolve) => {
            require(['@/views/users/company'], resolve);
        }
    },
    'addCompanyUserRoute': {
        'path': '/company/users/add',
        'name': 'add-company-users',
        'meta': {
            'title': 'Add Company Users',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/users/company/add'], resolve);
        }
    },
    'viewDoctorsPath': {
        'path': '/admin/doctors',
        'name': 'view-doctors',
        'meta': {
            'title': 'Doctor List',
            'icon': 'fa-user-md'
        },
        'component': (resolve) => {
            require(['@/views/doctors'], resolve);
        }
    },
    'viewClinicsPath': {
        'path': '/admin/clinics',
        'name': 'view-clinics',
        'meta': {
            'title': 'Clinic List',
            'icon': 'fa-plus-square'
        },
        'component': (resolve) => {
            require(['@/views/clinics'], resolve);
        }
    },
    'viewOptometristsPath': {
        'path': '/admin/optometrists',
        'name': 'view-optometrists',
        'meta': {
            'title': 'Optometrist List',
            'icon': 'fa-eye',
            'clinicType': 2
        },
        'component': (resolve) => {
            require(['@/views/clinics'], resolve);
        }
    },
    'drugListRoute': {
        'path': '/drugs-management',
        'name': 'list-drugs',
        'meta': {
            'title': 'Drugs Management',
            'icon': 'fa-pills'
        },
        'component': (resolve) => {
            require(['@/views/drugs/list'], resolve);
        }
    },
    'drugDetailRoute': {
        'path': '/drugs-management/detail/:id',
        'name': 'drug-detail',
        'meta': {
            'title': 'Drugs Details'
        },
        'component': (resolve) => {
            require(['@/views/drugs/detail'], resolve);
        }
    },
    'drugAddRoute': {
        'path': '/drugs-management/new',
        'name': 'drug-detail-add',
        'meta': {
            'title': 'Add New Drug'
        },
        'component': (resolve) => {
            require(['@/views/drugs/detail'], resolve);
        }
    },
    'drugBulkProcessRoute': {
        'path': '/drugs-management/bulk-upload',
        'name': 'drug-upload',
        'meta': {
            'title': 'Bulk Upload Drugs'
        },
        'component': (resolve) => {
            require(['@/views/drugs/bulk-upload'], resolve);
        }
    },
    'doctorCreateTimeSlotRoute': {
        'path': '/doctor/calendar/create',
        'name': 'doctor-create-timeslots',
        'meta': {
            'title': 'Create Timeslots'
        },
        'component': (resolve) => {
            require(['@/views/calendar/doctor/create'], resolve);
        }
    },
    'userMedicalReportsRoute': {
        'path': '/user/medical-reports',
        'name': 'user-medical-report',
        'meta': {
            'title': 'Medical Reports',
            'icon': 'fa-file-contract'
        },
        'component': (resolve) => {
            require(['@/views/medical-reports/user/index'], resolve);
        }
    },
    'userMedicalReportDetailRoute': {
        'path': '/user/medical-reports/detail/:id',
        'name': 'user-medical-report-detail',
        'meta': {
            'title': 'Medical Report Details'
        },
        'component': (resolve) => {
            require(['@/views/medical-reports/user/detail'], resolve);
        }
    },
    'doctorMedicalReportDetailRoute': {
        'path': '/doctor/medical-reports/detail/:id',
        'name': 'doctor-medical-report-detail',
        'meta': {
            'title': 'Medical Report Details'
        },
        'component': (resolve) => {
            require(['@/views/medical-reports/doctor/detail'], resolve);
        }
    },
    'userUploadPrescription': {
        'path': '/user/prescription/upload',
        'name': 'user-upload-prescription',
        'meta': {
            'title': 'Upload Doctor\'s Prescription',
            'icon': 'fa-file-upload'
        },
        'component': (resolve) => {
            require(['@/views/prescription/user/upload'], resolve);
        }
    },
    'userPrescriptionList': {
        'path': '/user/prescription/list',
        'name': 'user-prescription-list',
        'meta': {
            'title': 'My Prescriptions',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/prescription/user/index'], resolve);
        }
    },
    'userPrescriptionDetails': {
        'path': '/user/prescription/detail/:id',
        'name': 'user-prescription-detail',
        'meta': {
            'title': 'Prescription Details'
        },
        'component': (resolve) => {
            require(['@/views/prescription/user/detail'], resolve);
        }
    },
    'pharmacyPrescriptionList': {
        'path': '/pharmacy/prescription/new',
        'name': 'pharmacy-prescription-new',
        'meta': {
            'title': 'Prescription Orders',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/prescription/pharmacy/index'], resolve);
        }
    },
    'pharmacyPrescriptionPrepareList': {
        'path': '/pharmacy/prescription/in-prepare',
        'name': 'pharmacy-prescription-prepare',
        'meta': {
            'title': 'Prescription - In Prepare',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/prescription/pharmacy/prepare-list'], resolve);
        }
    },
    'pharmacyPrescriptionDeliveryList': {
        'path': '/pharmacy/prescription/shipped',
        'name': 'pharmacy-prescription-shipped',
        'meta': {
            'title': 'Prescription - Shipped',
            'icon': 'fa-shipping-fast'
        },
        'component': (resolve) => {
            require(['@/views/prescription/pharmacy/shipped-list'], resolve);
        }
    },
    'pharmacyPrescriptionDetailsRoute': {
        'path': '/pharmacy/prescription/detail/:id',
        'name': 'pharmacy-prescription-detail',
        'meta': {
            'title': 'Prescription Details'
        },
        'component': (resolve) => {
            require(['@/views/prescription/pharmacy/detail'], resolve);
        }
    },
    'userPaymentListRoute': {
        'path': '/payments/my-payments',
        'name': 'user-payment-list',
        'meta': {
            'title': 'My Payments',
            'icon': 'fa-credit-card'
        },
        'component': (resolve) => {
            require(['@/views/payment/user/index'], resolve);
        }
    },
    'userAppointmentToPayListRoute': {
        'path': '/user/doctor-appointment-to-pay',
        'name': 'user-doctor-appointment-to-pay',
        'meta': {
            'title': 'Consultations - To Pay',
            'icon': 'fa-file-invoice'
        },
        'component': (resolve) => {
            require(['@/views/appointments/user/doctor/to-pay-list'], resolve);
        }
    },
    'userAppointmentCancelledListRoute': {
        'path': '/user/doctor-appointment-cancelled',
        'name': 'user-doctor-appointment-cancelled',
        'meta': {
            'title': 'Consultations - Cancelled',
            'icon': 'fa-calendar-times'
        },
        'component': (resolve) => {
            require(['@/views/appointments/user/doctor/cancelled-list'], resolve);
        }
    },
    'userWalletRoute': {
        'path': '/user/credit-balance',
        'name': 'user-credit-balance',
        'meta': {
            'title': 'Credit Balance',
            'icon': 'fa-wallet'
        },
        'component': (resolve) => {
            require(['@/views/wallet'], resolve);
        }
    },
    'userRemindersRoute': {
        'path': '/user/reminders',
        'name': 'user-reminders',
        'meta': {
            'title': 'Medicine Intake Reminders',
            'icon': 'fa-bell'
        },
        'component': (resolve) => {
            require(['@/views/reminders'], resolve);
        }
    },
    'companyWalletRoute': {
        'path': '/company/credit/manage-credit',
        'name': 'company-manage-credit',
        'meta': {
            'title': 'Manage Company Credit',
            'icon': 'fa-wallet'
        },
        'component': (resolve) => {
            require(['@/views/company-wallet'], resolve);
        }
    },
    'companySettingsRoute': {
        'path': '/company/settings',
        'name': 'company-settings',
        'meta': {
            'title': 'Company Settings',
            'icon': 'fa-cog'
        },
        'component': (resolve) => {
            require(['@/views/settings/company'], resolve);
        }
    },
    'companyEmployeeCreditUsageRoute': {
        'path': '/company/credit/employee-credit-usage',
        'name': 'employee-credit-usage',
        'meta': {
            'title': 'Employee Credit Usage',
            'icon': 'fa-dollar-sign'
        },
        'component': (resolve) => {
            require(['@/views/company-wallet/employee-credit-usage'], resolve);
        }
    },
    'companyEmployeeSpendingReportRoute': {
        'path': '/company/credit/employee-spending-report',
        'name': 'employee-spending-report',
        'meta': {
            'title': 'Employee Spending Report',
            'icon': 'fa-file-invoice-dollar'
        },
        'component': (resolve) => {
            require(['@/views/company-wallet/employee-spending-report'], resolve);
        }
    },
    'employeeCompanyCreditBalance': {
        'path': '/user/company-credit-balance',
        'name': 'company-credit-balance',
        'meta': {
            'title': 'Company Credit Balance',
            'icon': 'fa-building'
        },
        'component': (resolve) => {
            require(['@/views/company-wallet/company-credit-balance'], resolve);
        }
    },
    'companyInviteUsers': {
        'path': '/company/users/invite-users',
        'name': 'company-invite-users',
        'meta': {
            'title': 'Invite Users',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/company'], resolve);
        }
    },
    'companyBulkInviteUsers': {
        'path': '/company/users/bulk-invite-users',
        'name': 'company-bulk-invite-users',
        'component': (resolve) => {
            require(['@/views/invite-users/company/bulk-invite'], resolve);
        }
    },
    'companyUserInvitationReport': {
        'path': '/company/users/invitation-report',
        'name': 'company-user-invitation-report',
        'meta': {
            'title': 'User Invitation Report',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/company/invitation-report'], resolve);
        }
    },
    'adminInvitationModule': {
        'path': '/admin/invitation-module',
        'name': 'admin-invite-users',
        'meta': {
            'title': 'Invitation Module',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/admin'], resolve);
        }
    },
    'adminInviteCompany': {
        'path': '/admin/companies/invite',
        'name': 'admin-invite-company',
        'component': (resolve) => {
            require(['@/views/invite-users/admin/invite-company'], resolve);
        }
    },
    'adminInvitePharmacy': {
        'path': '/admin/pharmacies/invite',
        'name': 'admin-invite-pharmacy',
        'component': (resolve) => {
            require(['@/views/invite-users/admin/invite-pharmacy'], resolve);
        }
    },
    'adminInviteDoctor': {
        'path': '/admin/clinics/invite',
        'name': 'admin-invite-clinic',
        'component': (resolve) => {
            require(['@/views/invite-users/admin/invite-clinic'], resolve);
        }
    },
    'adminInviteCinic': {
        'path': '/admin/doctors/invite',
        'name': 'admin-invite-doctor',
        'component': (resolve) => {
            require(['@/views/invite-users/admin/invite-doctor'], resolve);
        }
    },
    'adminInvitePublicUser': {
        'path': '/admin/users/invite',
        'name': 'admin-invite-user',
        'component': (resolve) => {
            require(['@/views/invite-users/admin/invite-public'], resolve);
        }
    },
    'adminInvitationReport': {
        'path': '/admin/users/invitation-report',
        'name': 'admin-user-invitation-report',
        'component': (resolve) => {
            require(['@/views/invite-users/admin/invitation-report'], resolve);
        }
    },
    'adminPayoutModule': {
        'path': '/admin/payout',
        'name': 'admin-partner-payout',
        'meta': {
            'title': 'Partner Payouts (Itemized and Search)',
            'icon': 'fa-money-bill-alt'
        },
        'component': (resolve) => {
            require(['@/views/payouts/admin'], resolve);
        }
    },
    'adminPayoutV2Module': {
        'path': '/admin/payout/v2',
        'name': 'admin-partner-payout-v2',
        'meta': {
            'title': 'Partner Payouts (New)',
            'icon': 'fa-money-bill-alt'
        },
        'component': (resolve) => {
            require(['@/views/payouts/admin/indexV2'], resolve);
        }
    },
    'adminPayoutDetailModule': {
        'path': '/admin/payout/detail/:paymentId',
        'name': 'admin-partner-payout-detail',
        'component': (resolve) => {
            require(['@/views/payouts/admin/detail'], resolve);
        }
    },
    'adminPayoutDetailV2Module': {
        'path': '/admin/payout/detail/role/:role/id/:roleId',
        'name': 'admin-partner-payout-detail-v2',
        'component': (resolve) => {
            require(['@/views/payouts/admin/detailV2'], resolve);
        }
    },
    'adminReceivedPaymentsModule': {
        'path': '/admin/received-payments',
        'name': 'admin-received-payments',
        'meta': {
            'title': 'Received Payments',
            'icon': 'fa-file-invoice-dollar'
        },
        'component': (resolve) => {
            require(['@/views/payment/admin/received'], resolve);
        }
    },
    'adminReceivedPaymentDetailModule': {
        'path': '/admin/received-payments/detail/:paymentId',
        'name': 'admin-received-payment-detail',
        'component': (resolve) => {
            require(['@/views/payment/admin/detail'], resolve);
        }
    },
    'tpaProfileModule': {
        'path': '/tpa/profile',
        'name': 'tpa-profile',
        'meta': {
            'title': 'TPA Profile',
            'icon': 'fa-info-circle'
        },
        'component': (resolve) => {
            require(['@/views/profile/tpa'], resolve);
        }
    },
    'tpaInviteNewCompanyModule': {
        'path': '/tpa/invite-company',
        'name': 'tpa-invite-company',
        'meta': {
            'title': 'Invite New Company',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/tpa/invite-company'], resolve);
        }
    },
    'tpaCompanyInvitationReportModule': {
        'path': '/tpa/report/invite-company',
        'name': 'tpa-company-invitation-report',
        'meta': {
            'title': 'Company Invitation Report',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/tpa/invitation-report'], resolve);
        }
    },
    'tpaEnrolledCompaniesModule': {
        'path': '/tpa/enrolments/companies',
        'name': 'tpa-enrolled-companies',
        'meta': {
            'title': 'Enrolled Companies',
            'icon': 'fa-building'
        },
        'component': (resolve) => {
            require(['@/views/tpa/enrolled-companies'], resolve);
        }
    },
    'clinicWalkInModule': {
        'path': '/clinic/walk-in',
        'name': 'clinic-walk-in',
        'meta': {
            'title': 'Patient QR Code Check In',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/clinic/walk-in'], resolve);
        }
    },
    'clinicRegisterModule': {
        'path': '/clinic/check-in',
        'name': 'clinic-check-in-registered-patient',
        'meta': {
            'title': 'Check In Registered Patient',
            'icon': 'fa-edit'
        },
        'component': (resolve) => {
            require(['@/views/clinic/check-in-registered-patient'], resolve);
        }
    },
    'clinicDoctorPatientDetail': {
        'path': '/clinic/consultation',
        'name': 'clinic-patient-consultation',
        'component': (resolve) => {
            require(['@/views/clinic-demo/consultation'], resolve);
        }
    },
    'clinicCheckIn': {
        'path': '/clinic-check-in',
        'name': 'clinic-check-in',
        'component': (resolve) => {
            require(['@/views/clinic/check-in'], resolve);
        }
    },
    'clinicPendingPayments': {
        'path': '/clinic/consultations',
        'name': 'clinic-consultation-list',
        'meta': {
            'title': 'Dispensing and Payments',
            'icon': 'fa-money-bill-wave'
        },
        'component': (resolve) => {
            require(['@/views/clinic/consultation-list'], resolve);
        }
    },
    'clinicNewPrescription': {
        'path': '/clinic/payment-details/new-prescription/:patientId',
        'name': 'clinic-new-prescription',
        'meta': {
            'title': 'Dispensing and Payments',
            'icon': 'fa-money-bill-wave'
        },
        'component': (resolve) => {
            require(['@/views/clinic/new-prescription'], resolve);
        }
    },
    'clinicRegisterNewPatient': {
        'path': '/clinic/register-new-patient',
        'name': 'clinic-register-new-patient',
        'meta': {
            'title': 'Register New Patient',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/clinic/register-new-patient'], resolve);
        }
    },
    'clinicStaffManagement': {
        'path': '/clinic/staff-management',
        'name': 'clinic-staff-management',
        'meta': {
            'title': 'Staff Management',
            'icon': 'fa-lock'
        },
        'component': (resolve) => {
            require(['@/views/clinic/staff-management/index'], resolve);
        }
    },
    'createClinicStaff': {
        'path': '/clinic/staff-management/create',
        'name': 'create-clinic-staff',
        'meta': {
            'title': 'Create Clinic Staff',
            'icon': 'fa-lock'
        },
        'component': (resolve) => {
            require(['@/views/clinic/staff-management/form'], resolve);
        }
    },
    'editClinicStaff': {
        'path': '/clinic/staff-management/:id',
        'name': 'edit-clinic-staff',
        'meta': {
            'title': 'Edit Clinic Staff',
            'icon': 'fa-lock'
        },
        'component': (resolve) => {
            require(['@/views/clinic/staff-management/form'], resolve);
        }
    },
    'staffChangePassword': {
        'path': '/staff/change-password',
        'name': 'staff-change-password',
        'meta': {
            'title': 'Change Password',
            'icon': 'fa-lock'
        },
        'component': (resolve) => {
            require(['@/views/clinic/staff-management/change-password'], resolve);
        }
    },
    'clinicPaymentDetails': {
        'path': '/clinic/payment-details/:clinicPaymentId',
        'name': 'clinic-payment-details',
        'component': (resolve) => {
            require(['@/views/clinic/payment-details'], resolve);
        }
    },

    // 'clinicCollectedPayments': {
    //     'path': '/clinic/consultations',
    //     'name': 'clinic-consultation-list',
    //     'meta': {
    //         'title': 'All Payments',
    //         'icon': 'fa-file-invoice-dollar'
    //     },
    //     'component': (resolve) => {
    //         require(['@/views/clinic/consultation-list'], resolve);
    //     }
    // },
    'clinicConsultationDetails': {
        'path': '/clinic/consultation/:id',
        'name': 'clinic-consultation-details',
        'component': (resolve) => {
            require(['@/views/clinic/consultation-detail'], resolve);
        }
    },
    'clinicPastConsultationDetails': {
        'path': '/clinic/past/consultation/:id',
        'name': 'clinic-past-consultation-details',
        'component': (resolve) => {
            require(['@/views/clinic/consultation-detail'], resolve);
        }
    },
    // 'clinicConsultationDetailsNew': {
    //     'path': '/clinic/consultation-new/:consultationId',
    //     'name': 'clinic-consultation-details-new',
    //     'component': (resolve) => {
    //         require(['@/views/clinic/consultation-detail-new'], resolve);
    //     }
    // },
    'userConsultationMedicineDeliveryList': {
        'path': '/user/consultation-medicine-delivery/list',
        'name': 'user-consultation-medicine-delivery-list',
        'meta': {
            'title': 'Medicine Delivery',
            'icon': 'fas fa-pills'
        },
        'component': (resolve) => {
            require(['@/views/consultation-medicine-delivery/user/'], resolve);
        }
    },
    'userConsultationMedicineDeliveryDetail': {
        'path': '/user/consultation-medicine-delivery/detail/:id',
        'name': 'user-consultation-medicine-delivery-detail',
        'meta': {
            'title': 'Consultation Medication Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation-medicine-delivery/user/detail'], resolve);
        }
    },
    'doctorConsultationMedicineDeliveryList': {
        'path': '/doctor/consultation-medicine-delivery/list',
        'name': 'doctor-consultation-medicine-delivery-list',
        'meta': {
            'title': 'Medicine Delivery',
            'icon': 'fas fa-pills'
        },
        'component': (resolve) => {
            require(['@/views/consultation-medicine-delivery/doctor/'], resolve);
        }
    },
    'doctorConsultationMedicineDeliveryDetail': {
        'path': '/doctor/consultation-medicine-delivery/detail/:id',
        'name': 'doctor-consultation-medicine-delivery-detail',
        'meta': {
            'title': 'Consultation Medication Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation-medicine-delivery/doctor/detail'], resolve);
        }
    },
    'superadminDoctorApprovalDetail': {
        'path': '/superadmin/doctor-approval/:id',
        'name': 'superadmin-doctor-approval',
        'meta': {
            'title': 'Doctor Approval'
        },
        'component': (resolve) => {
            require(['@/views/doctor-approval/'], resolve);
        }
    },
    'superadminClinicApprovalDetail': {
        'path': '/superadmin/clinic-approval/:id',
        'name': 'superadmin-clinic-approval',
        'meta': {
            'title': 'Clinic Approval'
        },
        'component': (resolve) => {
            require(['@/views/clinic-approval/'], resolve);
        }
    },
    'doctorInviteUserModule': {
        'path': '/doctor/invite-patient',
        'name': 'doctor-invite-patient',
        'meta': {
            'title': 'Invite Patients',
            'icon': 'fas fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/doctor'], resolve);
        }
    },
    'doctorBulkInviteUserModule': {
        'path': '/doctor/bulk-invite-patient',
        'name': 'doctor-bulk-invite-patient',
        'meta': {
            'title': 'Bulk Invite Patients'
        },
        'component': (resolve) => {
            require(['@/views/invite-users/doctor/bulk-invite'], resolve);
        }
    },
    'resetPasswordModule': {
        'path': '/reset-password',
        'name': 'reset-password',
        'meta': {
            'title': 'Reset Password',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/reset-password'], resolve);
        }
    },
    'viewPatientsPath': {
        'path': '/admin/patients',
        'name': 'admin-view-patients',
        'meta': {
            'title': 'Patient List',
            'icon': 'fa-users'
        },
        'component': (resolve) => {
            require(['@/views/patients'], resolve);
        }
    },
    'viewPatientDetailsPath': {
        'path': '/admin/view-patient/:id',
        'name': 'admin-view-patient',
        'meta': {
            'title': 'Patient Details'
        },
        'component': (resolve) => {
            require(['@/views/patients/detail'], resolve);
        }
    },
    'videoGuideDoctorPath': {
        'path': '/video-guide/doctor',
        'name': 'video-guide-doctor',
        'meta': {
            'title': 'Video Guide',
            'icon': 'fa-film'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/doctor'], resolve);
        }
    },
    'videoGuideUserPath': {
        'path': '/video-guide/user',
        'name': 'video-guide-user',
        'meta': {
            'title': 'Video Guide',
            'icon': 'fa-film'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/user'], resolve);
        }
    },
    'patientQueuePath': {
        'path': '/clinic/patient-queue',
        'name': 'clinic-patient-queue',
        'meta': {
            'title': 'Patient Queue',
            'icon': 'fa-user-friends'
        },
        'component': (resolve) => {
            require(['@/views/clinic/patient-queue'], resolve);
        }
    },
    'patientPastPrescriptions': {
        'path': '/clinic/past-prescriptions/:patientId',
        'name': 'clinic-past-prescriptions',
        'meta': {
            'title': 'Past Prescriptions'
        },
        'component': (resolve) => {
            require(['@/views/clinic/past-prescriptions'], resolve);
        }
    },
    'medicalCertificatesList': {
        'path': '/medical-certificates/list',
        'name': 'medical-certificates-list',
        'meta': {
            'title': 'Medical Certificates',
            'icon': 'fa-file'
        },
        'component': (resolve) => {
            require(['@/views/medical-certificates'], resolve);
        }
    },
    'medicalCertificate': {
        'path': '/medical-certificates/:id',
        'name': 'medical-certificate',
        'meta': {
            'title': 'Medical Certificate',
            'icon': 'fa-file'
        },
        'component': (resolve) => {
            require(['@/views/medical-certificates/view'], resolve);
        }
    },
    'drugListIphRoute': {
        'path': '/pharmacy-drugs-management',
        'name': 'pharmacy-drugs-management',
        'meta': {
            'title': 'Drugs Management (IPH)',
            'icon': 'fa-pills'
        },
        'component': (resolve) => {
            require(['@/views/pharmacy-drugs/list'], resolve);
        }
    },
    'drugBulkProcessIphRoute': {
        'path': '/pharmacy-drugs-management/bulk-upload',
        'name': 'pharmacy-drugs-management-bulk-upload',
        'meta': {
            'title': 'Bulk Upload Drugs'
        },
        'component': (resolve) => {
            require(['@/views/pharmacy-drugs/bulk-upload'], resolve);
        }
    },
    'drugDetailIphRoute': {
        'path': '/pharmacy-drugs-management/detail/:id',
        'name': 'pharmacy-drugs-management-detail',
        'meta': {
            'title': 'Drugs Details'
        },
        'component': (resolve) => {
            require(['@/views/pharmacy-drugs/detail'], resolve);
        }
    },
    'drugAddIphRoute': {
        'path': '/pharmacy-drugs-management/new',
        'name': 'pharmacy-drugs-management-new',
        'meta': {
            'title': 'Add New Drug'
        },
        'component': (resolve) => {
            require(['@/views/pharmacy-drugs/detail'], resolve);
        }
    },
    'myEwalletApplicationRoute': {
        'path': '/e-wallet-application/mine',
        'name': 'my-e-wallet-application',
        'meta': {
            'title': 'E-Wallet Application',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/e-wallet-application/mine'], resolve);
        }
    },
    'adminListEwalletApplicationRoute': {
        'path': '/admin/e-wallet-applications',
        'name': 'e-wallet-application-admin-list',
        'meta': {
            'title': 'E-Wallet Applications',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/e-wallet-application/admin-list'], resolve);
        }
    },
    'adminViewEwalletApplicationRoute': {
        'path': '/admin/e-wallet-applications/:applicationId',
        'name': 'e-wallet-application-admin-view',
        'component': (resolve) => {
            require(['@/views/e-wallet-application/admin-view'], resolve);
        }
    },
    'viewTierPath': {
        'path': '/company/tier',
        'name': 'tier-list',
        'meta': {
            'title': 'Create Benefit Tier',
            'icon': 'fa-bars'
        },
        'component': (resolve) => {
            require(['@/views/tier/list'], resolve);
        }
    },
    'viewTierDetailPath': {
        'path': '/company/tier/detail',
        'name': 'tier-detail',
        'meta': {
            'title': 'Tier Detail'
        },
        'component': (resolve) => {
            require(['@/views/tier/detail'], resolve);
        }
    },
    'addTierDetailPath': {
        'path': '/company/tier/add',
        'name': 'tier-detail-add',
        'meta': {
            'title': 'Add New Tier'
        },
        'component': (resolve) => {
            require(['@/views/tier/detail'], resolve);
        }
    },
    'viewEmployeeTierPath': {
        'path': '/company/employee-tier',
        'name': 'employee-tier-list',
        'meta': {
            'title': 'Add / Delete Employees & Dependents',
            'icon': 'fa-sitemap'
        },
        'component': (resolve) => {
            require(['@/views/employee-tier/list'], resolve);
        }
    },
    'viewEmployeeDetailPath': {
        'path': '/company/employee-tier/detail',
        'name': 'employee-tier-detail',
        'meta': {
            'title': 'Employee Tier Detail'
        },
        'component': (resolve) => {
            require(['@/views/employee-tier/detail'], resolve);
        }
    },
    'addEmployeeDetailPath': {
        'path': '/company/employee-tier/add',
        'name': 'employee-tier-detail-add',
        'meta': {
            'title': 'Add New Employee Tier'
        },
        'component': (resolve) => {
            require(['@/views/employee-tier/detail'], resolve);
        }
    },
    'bulkAddEmployeePath': {
        'path': '/company/employee-tier/bulk-add',
        'name': 'employee-tier-bulk-add',
        'meta': {
            'title': 'Bulk Add New Employee'
        },
        'component': (resolve) => {
            require(['@/views/employee-tier/bulk-add'], resolve);
        }
    },
    'panelClinics': {
        'path': '/panel-clinics',
        'name': 'panel-clinics',
        'meta': {
            'title': 'Panel Clinics',
            'icon': 'fa-clinic-medical'
        },
        'component': (resolve) => {
            require(['@/views/panel-clinics'], resolve);
        }
    },
    'videoGuideClinicAdminPath': {
        'path': '/video-guide/clinic-admin',
        'name': 'video-guide-clinic-admin',
        'meta': {
            'title': 'Staff Management',
            'icon': 'fa-film'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/clinic-admin'], resolve);
        }
    },
    // 'videoGuideClinicDoctorPath': {
    //     'path': '/video-guide/clinic-doctor',
    //     'name': 'video-guide-clinic-doctor',
    //     'meta': {
    //         'title': 'Doctor Consultation',
    //         'icon': 'fa-user-md'
    //     },
    //     'component': (resolve) => {
    //         require(['@/views/video-guide/clinic-doctor'], resolve);
    //     }
    // },
    'videoGuideClinicNursePath': {
        'path': '/video-guide/clinic-nurse',
        'name': 'video-guide-clinic-nurse',
        'meta': {
            'title': 'Nurse Daily Operations',
            'icon': 'fa-user-nurse'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/clinic-nurse'], resolve);
        }
    },
    'registerClinicRoute': {
        'path': '/register-clinic',
        'name': 'register-clinic',
        'meta': {
            'title': 'Register New Clinic',
            'icon': 'fa-user-plus',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/register'], resolve);
        }
    },
    'registerOptometristRoute': {
        'path': '/register-optometrist',
        'name': 'register-optometrist',
        'meta': {
            'title': 'Register New Optometrist',
            'icon': 'fa-user-plus',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/register'], resolve);
        }
    },
    'registerNewAccountLanding': {
        'path': '/register-landing',
        'name': 'register-landing',
        'component': (resolve) => {
            require(['@/views/account/register-landing'], resolve);
        },
        'meta': {
            'shouldNotRequireLogin': true
        }
    },
    'changeCompanyType': {
        'path': '/company/change-type',
        'name': 'change-company-type',
        'meta': {
            'title': 'Change Company Type',
            'icon': 'fa-exchange-alt'
        },
        'component': (resolve) => {
            require(['@/views/company/change-type'], resolve);
        }
    },
    'viewCompanySelfPayingEmployeeList': {
        'path': '/company/employee-list',
        'name': 'employee-self-paying-list',
        'meta': {
            'title': 'Employee List',
            'icon': 'fa-users'
        },
        'component': (resolve) => {
            require(['@/views/employee-self-paying/list'], resolve);
        }
    },
    'viewCompanySelfPayingEmployeeDetail': {
        'path': '/company/employee/detail',
        'name': 'employee-self-paying-detail',
        'meta': {
            'title': 'Employee Details'
        },
        'component': (resolve) => {
            require(['@/views/employee-self-paying/detail'], resolve);
        }
    },
    'addCompanySelfPayingEmployeeDetail': {
        'path': '/company/employee/add',
        'name': 'employee-self-paying-detail-add',
        'meta': {
            'title': 'Add New Employee'
        },
        'component': (resolve) => {
            require(['@/views/employee-self-paying/detail'], resolve);
        }
    },
    'bulkAddSelfPayingEmployeePath': {
        'path': '/company/employee/bulk-add',
        'name': 'employee-self-paying-bulk-add',
        'meta': {
            'title': 'Bulk Add New Employees'
        },
        'component': (resolve) => {
            require(['@/views/employee-self-paying/bulk-add'], resolve);
        }
    },
    'viewFamilyPath': {
        'path': '/family',
        'name': 'family-list',
        'meta': {
            'title': 'Family Member List',
            'icon': 'fa-sitemap'
        },
        'component': (resolve) => {
            require(['@/views/family/list'], resolve);
        }
    },
    'viewFamilyDetailPath': {
        'path': '/family/detail/:id',
        'name': 'family-detail',
        'meta': {
            'title': 'Family Member Detail'
        },
        'component': (resolve) => {
            require(['@/views/family/detail'], resolve);
        }
    },
    'addFamilyDetailPath': {
        'path': '/family/add',
        'name': 'family-detail-add',
        'meta': {
            'title': 'Add Family Member'
        },
        'component': (resolve) => {
            require(['@/views/family/detail'], resolve);
        }
    },
    'familyClinicConsultationHistoryListRoute': {
        'path': '/family/clinic-consultation/list',
        'name': 'family-clinic-consultation-list',
        'meta': {
            'title': 'Family Clinic Consultations',
            'icon': 'fa-history'
        },
        'component': (resolve) => {
            require(['@/views/consultation/clinic/list'], resolve);
        }
    },
    'familyClinicConsultationDetailRoute': {
        'path': '/family/clinic-consultation/detail/:id',
        'name': 'family-clinic-consultation-detail',
        'meta': {
            'title': 'Consultation Details'
        },
        'component': (resolve) => {
            require(['@/views/consultation/clinic/detail'], resolve);
        }
    },
    'familyUploadPrescription': {
        'path': '/family/prescription/upload',
        'name': 'family-upload-prescription',
        'meta': {
            'title': 'Upload Doctor\'s Prescription',
            'icon': 'fa-file-upload'
        },
        'component': (resolve) => {
            require(['@/views/prescription/user/upload'], resolve);
        }
    },
    'familyPrescriptionList': {
        'path': '/family/prescription/list',
        'name': 'family-prescription-list',
        'meta': {
            'title': 'Family Prescriptions',
            'icon': 'fa-file-alt'
        },
        'component': (resolve) => {
            require(['@/views/prescription/user/index'], resolve);
        }
    },
    'familyPrescriptionDetails': {
        'path': '/family/prescription/detail/:id',
        'name': 'family-prescription-detail',
        'meta': {
            'title': 'Prescription Details'
        },
        'component': (resolve) => {
            require(['@/views/prescription/user/detail'], resolve);
        }
    },
    'familyMedicalReportsRoute': {
        'path': '/family/medical-reports',
        'name': 'family-medical-report',
        'meta': {
            'title': 'Family Medical Reports',
            'icon': 'fa-file-contract'
        },
        'component': (resolve) => {
            require(['@/views/medical-reports/user/index'], resolve);
        }
    },
    'familyMedicalReportDetailRoute': {
        'path': '/family/medical-reports/detail/:id',
        'name': 'family-medical-report-detail',
        'meta': {
            'title': 'Medical Report Details'
        },
        'component': (resolve) => {
            require(['@/views/medical-reports/user/detail'], resolve);
        }
    },
    'familyMedicalCertificatesList': {
        'path': '/family/medical-certificates/list',
        'name': 'family-medical-certificates-list',
        'meta': {
            'title': 'Medical Certificates',
            'icon': 'fa-file'
        },
        'component': (resolve) => {
            require(['@/views/medical-certificates'], resolve);
        }
    },
    'newsletterRoute': {
        'path': '/newsletter',
        'name': 'newsletter',
        'meta': {
            'title': 'Newsletter (New)',
            'icon': 'fas fa-rss'
        },
        'component': (resolve) => {
            require(['@/views/newsletter'], resolve);
        }
    },
    'newsletterHistoryRoute': {
        'path': '/newsletter/history',
        'name': 'newsletter-history',
        'meta': {
            'title': 'Newsletter History',
            'icon': 'fas fa-history'
        },
        'component': (resolve) => {
            require(['@/views/newsletter/history-list'], resolve);
        }
    },
    'newsletterHistoryDetailRoute': {
        'path': '/newsletter/history/:id',
        'name': 'newsletter-history-detail',
        'component': (resolve) => {
            require(['@/views/newsletter/history'], resolve);
        }
    },
    'videoGuideCorporateSponsoredCreateTierAndSetBenefits': {
        'path': '/video-guide/corporate/corporate-sponsored/create-and-set-benefits',
        'name': 'video-guide-corporate-sponsored-create-and-set-benefits',
        'meta': {
            'title': 'Create Tier and Set Benefits',
            'icon': 'fa-plus-square'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/corporate-sponsored-add-tier'], resolve);
        }
    },
    'videoGuideCorporateSponsoredAddNewEmployee': {
        'path': '/video-guide/corporate/corporate-sponsored/add-new-employee',
        'name': 'video-guide-corporate-sponsored-add-new-employee',
        'meta': {
            'title': 'Add New Employee',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/corporate-sponsored-add-employee'], resolve);
        }
    },
    'videoGuideSelfPayingAddNewEmployee': {
        'path': '/video-guide/corporate/self-paying/add-new-employee',
        'name': 'video-guide-self-paying-add-new-employee',
        'meta': {
            'title': 'Add New Employee',
            'icon': 'fa-user-plus'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/self-paying-add-employee'], resolve);
        }
    },
    'videoGuideSelfPayingDeactivateEmployee': {
        'path': '/video-guide/corporate/self-paying/deactivate-employee',
        'name': 'video-guide-self-paying-deactivate-employee',
        'meta': {
            'title': 'Deactivate Employee',
            'icon': 'fa-user-minus'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/self-paying-deactivate-employee'], resolve);
        }
    },
    'videoGuidePanelClinicCheckIn': {
        'path': '/video-guide/panel-clinic-check-in',
        'name': 'Panel Clinic Check In',
        'meta': {
            'title': 'Panel Clinic Check In',
            'icon': 'fa-clinic-medical'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/check-in-panel-clinic'], resolve);
        }
    },
    'videoGuidePanelClinicDoctorConsultationGuideDetailed': {
        'path': '/video-guide/clinic-doctor/consultation-guide-detailed',
        'name': 'video-guide-clinic-doctor-consultation-guide-detailed',
        'meta': {
            'title': 'Doctor Consultation Guide',
            'icon': 'fa-stethoscope'
        },
        'component': (resolve) => {
            require(['@/views/video-guide/clinic-doctor-detailed-consultation-guide'], resolve);
        }
    },
    'vaccinationCentreLogin': {
        'path': '/vaccination-centre/login',
        'name': 'vaccination-centre-login',
        'meta': {
            'withoutPageWrapper': true,
            'title': 'Vaccination Centre Login',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/login'], resolve);
        }
    },
    'registerVaccinationCentre': {
        'path': '/vaccination-centre/register',
        'name': 'register-vaccination-centre',
        'meta': {
            'title': 'Register Vaccination Centre',
            'icon': 'fas fa-user-plus',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/vaccination-centre/register'], resolve);
        }
    },
    'vaccinationCentreDashboard': {
        'path': '/vaccination-centre/dashboard',
        'name': 'vaccination-centre-dashboard',
        'meta': {
            'title': 'Dashboard',
            'icon': 'fa-chart-pie'
        },
        'component': (resolve) => {
            require(['@/views/vaccination-centre'], resolve);
        }
    },
    'vaccinationCentreProfile': {
        'path': '/vaccination-centre/profile',
        'name': 'vaccination-centre-profile',
        'meta': {
            'title': 'Profile',
            'icon': 'fa-hospital'
        },
        'component': (resolve) => {
            require(['@/views/vaccination-centre/profile'], resolve);
        }
    },
    'adminVaccinationCentreList': {
        'path': '/admin/vaccination-centres',
        'name': 'admin-vaccination-centres',
        'meta': {
            'title': 'Vaccination Clinic List',
            'icon': 'fa-hospital'
        },
        'component': (resolve) => {
            require(['@/views/vaccination-centre/list'], resolve);
        }
    },
    'adminVaccinationCentreDetail': {
        'path': '/admin/vaccination-centre/:id',
        'name': 'admin-vaccination-centre',
        'component': (resolve) => {
            require(['@/views/vaccination-centre/detail'], resolve);
        }
    },
    'userVaccinationBooking': {
        'path': '/user/vaccination/booking',
        'name': 'user-vaccination-booking',
        'meta': {
            'title': 'Booking',
            'icon': 'far fa-bookmark'
        },
        'component': (resolve) => {
            require(['@/views/vaccination/user-booking'], resolve);
        }
    },
    'companyVaccinationBooking': {
        'path': '/company/vaccination/booking',
        'name': 'company-vaccination-booking',
        'meta': {
            'title': 'Booking',
            'icon': 'far fa-bookmark'
        },
        'component': (resolve) => {
            require(['@/views/vaccination/company-booking'], resolve);
        }
    },
    'myVaccinations': {
        'path': '/my-vaccinations',
        'name': 'my-vaccination',
        'meta': {
            'title': 'My Vaccinations',
            'icon': 'fas fa-clipboard-list'
        },
        'component': (resolve) => {
            require(['@/views/vaccination/my-vaccinations'], resolve);
        }
    },
    'vaccinationDetail': {
        'path': '/vaccination/detail/:id',
        'name': 'vaccination-detail',
        'meta': {
            'title': 'Vaccination Detail'
        },
        'component': (resolve) => {
            require(['@/views/vaccination/detail'], resolve);
        }
    },
    'assignVaccinationClinic': {
        'path': '/vaccinations/assign-clinic',
        'name': 'vaccination-assign-clinic',
        'meta': {
            'title': 'Assign Clinic',
            'icon': 'fas fa-clipboard-list'
        },
        'component': (resolve) => {
            require(['@/views/vaccination/assign-clinic-list'], resolve);
        }
    },
    'partnerPayoutVaccinationList': {
        'path': '/vaccinations/partner-payout',
        'name': 'vaccination-partner-payout',
        'meta': {
            'title': 'Clinic Payout',
            'icon': 'fas fa-money-bill'
        },
        'component': (resolve) => {
            require(['@/views/vaccination/partner-payment-list'], resolve);
        }
    },
    'vaccinationList': {
        'path': '/vaccinations',
        'name': 'vaccinations',
        'meta': {
            'title': 'History',
            'icon': 'fas fa-list'
        },
        'component': (resolve) => {
            require(['@/views/vaccination'], resolve);
        }
    },
    'healthSavvyMembership': {
        'path': '/health-savvy-membership',
        'name': 'health-savvy-membership',
        'meta': {
            'title': 'Health Savvy Membership',
            'icon': 'fas fa-address-card'
        },
        'component': (resolve) => {
            require(['@/views/profile/membership'], resolve);
        }
    },
    'viewPaymentReceipt': {
        'path': '/payment-receipt/:id',
        'name': 'view-payment-receipt',
        'meta': {
            'title': 'View Payment Receipt'
        },
        'component': (resolve) => {
            require(['@/views/payment-document/viewer.vue'], resolve);
        }
    },
    'viewPaymentSlip': {
        'path': '/payment-slip/:id',
        'name': 'view-payment-slip',
        'meta': {
            'title': 'View Payment Slip'
        },
        'component': (resolve) => {
            require(['@/views/payment-document/viewer.vue'], resolve);
        }
    },
    'viewInvoice': {
        'path': '/invoice/:id',
        'name': 'view-invoice',
        'meta': {
            'title': 'View Invoice'
        },
        'component': (resolve) => {
            require(['@/views/payment-document/viewer.vue'], resolve);
        }
    },
    'profileVerification': {
        'path': '/profile-verification',
        'name': 'profile-verification',
        'meta': {
            'title': 'Profile Verification',
            'icon': 'fas fa-address-card'
        },
        'component': (resolve) => {
            require(['@/views/profile-verification/list'], resolve);
        }
    },
    'profileVerificationDetail': {
        'path': '/profile-verification/detail/:id',
        'name': 'profile-verification-detail',
        'meta': {
            'title': 'Profile Verification Detail'
        },
        'component': (resolve) => {
            require(['@/views/profile-verification/detail'], resolve);
        }
    },
    'changeEmailAddressRoute': {
        'path': '/change-email-address',
        'name': 'change-email-address',
        'meta': {
            'title': 'Change Email Address',
            'icon': 'fas fa-envelope',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/views/account/change-email-address'], resolve);
        }
    },
    'companyInvoiceRoute': {
        'path': '/company/invoices',
        'name': 'company-invoices',
        'meta': {
            'title': 'Invoices',
            'icon': 'fas fa-file-invoice'
        },
        'component': (resolve) => {
            require(['@/views/invoice/company'], resolve);
        }
    },
    'app_healthSavvyMembership': {
        'path': '/app-health-savvy-membership',
        'name': 'app_health-savvy-membership',
        'meta': {
            'layout': 'empty',
            'shouldNotRequireLogin': true
        },
        'component': (resolve) => {
            require(['@/components/health-savvy-member-benefit'], resolve);
        }
    },
    'adminPermissibleEditRoute': {
        'path': '/admin/permissible',
        'name': 'admin-permissible',
        'meta': {
            'title': 'Manage Permissible ICD 10 Codes',
            'icon': 'fas fa-file-invoice'
        },
        'component': (resolve) => {
            require(['@/views/admin/permissible'], resolve);
        }
    },
    'userManualReimbursement': {
        'path': '/user/manual-reimbursement',
        'name': 'user-manual-reimbursement',
        'meta': {
            'title': 'Manual Reimbursement',
            'icon': 'fas fa-dollar-sign'
        },
        'component': (resolve) => {
            require(['@/views/manual-reimbursement/user/list'], resolve);
        }
    },
    'userManualReimbursementDetail': {
        'path': '/user/manual-reimbursement/detail/:id',
        'name': 'user-manual-reimbursement-detail',
        'meta': {
            'title': 'Manual Reimbursement Detail'
        },
        'component': (resolve) => {
            require(['@/views/manual-reimbursement/user/detail'], resolve);
        }
    },
    'userManualReimbursementAdd': {
        'path': '/user/manual-reimbursement/add',
        'name': 'user-manual-reimbursement-add',
        'meta': {
            'title': 'Submmit Manual Reimbursement'
        },
        'component': (resolve) => {
            require(['@/views/manual-reimbursement/user/detail'], resolve);
        }
    },
    'companyManualReimbursement': {
        'path': '/company/manual-reimbursement',
        'name': 'company-manual-reimbursement',
        'meta': {
            'title': 'Manual Reimbursement',
            'icon': 'fas fa-dollar-sign'
        },
        'component': (resolve) => {
            require(['@/views/manual-reimbursement/company/list'], resolve);
        }
    },
    'companyManualReimbursementDetail': {
        'path': '/company/manual-reimbursement/detail/:id',
        'name': 'company-manual-reimbursement-detail',
        'meta': {
            'title': 'Manual Reimbursement Detail'
        },
        'component': (resolve) => {
            require(['@/views/manual-reimbursement/company/detail'], resolve);
        }
    },
    'companyManualReimbursementAdd': {
        'path': '/company/manual-reimbursement/add',
        'name': 'company-manual-reimbursement-add',
        'meta': {
            'title': 'Add Manual Reimbursement'
        },
        'component': (resolve) => {
            require(['@/views/manual-reimbursement/company/detail'], resolve);
        }
    },
    'companyAdminList': {
        'path': '/company/admins',
        'name': 'company-admins',
        'meta': {
            'title': 'Company Admins',
            'icon': 'fas fa-user-check'
        },
        'component': (resolve) => {
            require(['@/views/company/admins'], resolve);
        }
    },
    'companyAdminAdd': {
        'path': '/company/admins/create',
        'name': 'company-admins-create',
        'component': (resolve) => {
            require(['@/views/company/admins-create'], resolve);
        }
    },
    'adminViewCompanyTier': {
        'path': '/admin/company-tier',
        'name': 'admin-company-tier',
        'meta': {
            'title': 'View Company Tiers',
            'icon': 'fa fa-sitemap'
        },
        'component': (resolve) => {
            require(['@/views/admin/company-tier'], resolve);
        }
    },
    'adminViewCompanyTierDetail': {
        'path': '/admin/company-tier/detail/:id',
        'name': 'admin-company-tier-detail',
        'component': (resolve) => {
            require(['@/views/admin/company-tier-detail'], resolve);
        }
    },

    'referralModule': {
        'path': '/referral',
        'name': 'referral',
        'meta': {
            'title': 'Referral System',
            'icon': 'fa fa-sitemap'
        },
        'component': (resolve) => {
            require(['@/views/referral'], resolve);
        }
    },
    'zoomVideoDemoModule': {
        'path': '/zoom-test',
        'name': 'zoom-test',
        'component': (resolve) => {
            require(['@/components/zoom-video'], resolve);
        }
    }
};

// export const userSideMenu = [
//     AllRoutes.userDashboardRoute,
//     AllRoutes.userAddConsultationRoute,
//     AllRoutes.profileUserRoute,
//     AllRoutes.employeeCompanyCreditBalance,
//     AllRoutes.userWalletRoute,
//     AllRoutes.userRemindersRoute,
//     AllRoutes.userPaymentListRoute,
//     AllRoutes.userMedicalReportsRoute,
//     AllRoutes.userAppointmentToPayListRoute,
//     AllRoutes.userDoctorAppointmentListRoute,
//     AllRoutes.userAppointmentCancelledListRoute,
//     AllRoutes.userDoctorConsultationHistoryListRoute,
//     AllRoutes.medicalCertificatesList,
//     // AllRoutes.userConsultationMedicineDeliveryList
//     AllRoutes.userPrescriptionList,
//     AllRoutes.userUploadPrescription,
//     AllRoutes.videoGuideUserPath
// ];

export const userSideMenu = [
    {
        'name': 'Profile',
        'meta': {
            'title': 'My Profile',
            'icon': 'fa-user'
        },
        'parent': true,
        'expand': true,
        'childs': [
            AllRoutes.profileUserRoute,
            AllRoutes.healthSavvyMembership,
            AllRoutes.changePasswordRoute,
            AllRoutes.changeEmailAddressRoute,
            AllRoutes.medicalCertificatesList,
            AllRoutes.userPrescriptionList,
            AllRoutes.userMedicalReportsRoute
        ]
    },
    {
        'name': 'My Accounts',
        'meta': {
            'title': 'My Accounts',
            'icon': 'fa-user'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.employeeCompanyCreditBalance,
            AllRoutes.userManualReimbursement,
            AllRoutes.userWalletRoute,
            AllRoutes.userPaymentListRoute
        ]
    },
    {
        'name': 'Telehealth',
        'meta': {
            'title': 'Telehealth',
            'icon': 'fa-notes-medical'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.userDashboardRoute,
            AllRoutes.userAddConsultationRoute,
            AllRoutes.userDoctorAppointmentListRoute,
            AllRoutes.userAppointmentToPayListRoute,
            AllRoutes.userDoctorConsultationHistoryListRoute,
            AllRoutes.userAppointmentCancelledListRoute,
            AllRoutes.videoGuideUserPath
        ]
    },
    {
        'name': 'My Family',
        'meta': {
            'title': 'My Family',
            'icon': 'fa-users'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.viewFamilyPath,
            AllRoutes.familyMedicalCertificatesList,
            AllRoutes.familyPrescriptionList,
            AllRoutes.familyMedicalReportsRoute,
            AllRoutes.familyClinicConsultationHistoryListRoute
        ]
    },
    {
        'name': 'Clinic',
        'meta': {
            'title': 'Clinic',
            'icon': 'fa-plus-square'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.panelClinics,
            AllRoutes.userClinicConsultationHistoryListRoute
        ]
    },
    AllRoutes.referralModule,
    // AllRoutes.employeeCompanyCreditBalance,
    // AllRoutes.userWalletRoute,
    AllRoutes.userRemindersRoute,
    // AllRoutes.userPaymentListRoute,
    // AllRoutes.medicalCertificatesList,
    // AllRoutes.userPrescriptionList,
    // AllRoutes.userUploadPrescription
    // AllRoutes.userMedicalReportsRoute
    {
        'name': 'Video Guides',
        'meta': {
            'title': 'Video Guides',
            'icon': 'fa-film'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.videoGuidePanelClinicCheckIn
            // AllRoutes.videoGuideUserPath
        ]
    }
    // {
    //     'name': 'Covid-19 Vaccination',
    //     'meta': {
    //         'title': 'Covid-19 Vaccination',
    //         'icon': 'fas fa-syringe',
    //         'highlight': true
    //     },
    //     'parent': true,
    //     'expand': false,
    //     'childs': [
    //         AllRoutes.userVaccinationBooking,
    //         AllRoutes.myVaccinations
    //     ]
    // }
];

export const superAdminSideMenu = [
    AllRoutes.adminDashboardRoute,
    AllRoutes.profileUserRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute,
    AllRoutes.registerClinicRoute,
    AllRoutes.viewClinicsPath,
    AllRoutes.viewOptometristsPath,
    AllRoutes.viewDoctorsPath,
    AllRoutes.viewPatientsPath,
    AllRoutes.adminInvitationModule,
    AllRoutes.adminReceivedPaymentsModule,
    AllRoutes.adminPayoutV2Module,
    AllRoutes.adminPayoutModule,
    AllRoutes.newsletterRoute,
    AllRoutes.newsletterHistoryRoute,
    AllRoutes.profileVerification,
    // AllRoutes.adminListEwalletApplicationRoute
    // AllRoutes.systemSettingRoute
    // {
    //     'name': 'Covid-19 Vaccination',
    //     'meta': {
    //         'title': 'Covid-19 Vaccination',
    //         'icon': 'fas fa-syringe'
    //     },
    //     'parent': true,
    //     'expand': false,
    //     'childs': [
    //         AllRoutes.assignVaccinationClinic,
    //         AllRoutes.partnerPayoutVaccinationList,
    //         AllRoutes.vaccinationList,
    //         AllRoutes.adminVaccinationCentreList
    //     ]
    // },
    AllRoutes.adminPermissibleEditRoute,
    AllRoutes.adminViewCompanyTier
];

export const iphAdminSideMenu = [
    // AllRoutes.adminDashboardRoute,
    AllRoutes.profileUserRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute,
    AllRoutes.registerClinicRoute,
    AllRoutes.viewClinicsPath,
    AllRoutes.registerVaccinationCentre,
    AllRoutes.adminVaccinationCentreList,
    // AllRoutes.viewDoctorsPath,
    // AllRoutes.viewPatientsPath,
    AllRoutes.adminInvitationModule,
    AllRoutes.drugListIphRoute
    // AllRoutes.adminReceivedPaymentsModule,
    // AllRoutes.adminPayoutModule,
    // AllRoutes.adminListEwalletApplicationRoute
    // AllRoutes.systemSettingRoute
];

export const doctorSideMenu = [
    // AllRoutes.doctorDashboardRoute,
    AllRoutes.profileDoctorRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute,
    AllRoutes.doctorCalendarRoute,
    AllRoutes.doctorAppointmentRequestsRoute,
    AllRoutes.doctorAppointmentListRoute,
    // AllRoutes.doctorConsultationMedicineDeliveryList,
    AllRoutes.doctorInviteUserModule,
    AllRoutes.videoGuideDoctorPath
];

export const pharmacyAdminSideMenu = [
    // AllRoutes.pharmacyDashboardRoute,
    AllRoutes.profilePharmacyRoute,
    AllRoutes.profilePharmacyUserRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute,
    AllRoutes.drugListRoute,
    AllRoutes.pharmacyPrescriptionList,
    AllRoutes.pharmacyPrescriptionPrepareList,
    AllRoutes.pharmacyPrescriptionDeliveryList
];

export const pharmacyUserSideMenu = [
    // AllRoutes.pharmacyDashboardRoute,
    AllRoutes.profilePharmacyUserRoute,
    AllRoutes.drugListRoute
];

export const companyAdminSideMenu = [
    // AllRoutes.companyDashboardRoute,
    AllRoutes.profileCompanyRoute,
    AllRoutes.companyAdminList,
    AllRoutes.changeCompanyType,
    // AllRoutes.profileUserRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute,
    // AllRoutes.viewCompanyUserRoute,
    AllRoutes.medicalCertificatesList,
    AllRoutes.companyUserInvitationReport,
    AllRoutes.viewCompanySelfPayingEmployeeList,
    AllRoutes.companyWalletRoute,
    AllRoutes.companyEmployeeCreditUsageRoute,
    AllRoutes.companyEmployeeSpendingReportRoute,
    AllRoutes.companyManualReimbursement,
    {
        'name': 'Outpatient Benefit Limit Setting',
        'meta': {
            'title': 'Outpatient Benefit Limit Setting',
            'icon': 'fa-money-check-alt'
        },
        'parent': true,
        'expand': false,
        'childs': [
            // AllRoutes.companySettingsRoute,
            AllRoutes.viewTierPath,
            AllRoutes.viewEmployeeTierPath
        ]
    },
    AllRoutes.referralModule,
    AllRoutes.companyInvoiceRoute,
    {
        'name': 'Video Guides',
        'meta': {
            'title': 'Video Guides',
            'icon': 'fa-film'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.videoGuideCorporateSponsoredCreateTierAndSetBenefits,
            AllRoutes.videoGuideCorporateSponsoredAddNewEmployee,
            AllRoutes.videoGuideSelfPayingAddNewEmployee,
            AllRoutes.videoGuideSelfPayingDeactivateEmployee,
            AllRoutes.videoGuidePanelClinicCheckIn
        ]
    },
    AllRoutes.panelClinics
    // {
    //     'name': 'Covid-19 Vaccination',
    //     'meta': {
    //         'title': 'Covid-19 Vaccination',
    //         'icon': 'fas fa-syringe',
    //         'highlight': true
    //     },
    //     'parent': true,
    //     'expand': false,
    //     'childs': [
    //         AllRoutes.companyVaccinationBooking,
    //         AllRoutes.myVaccinations
    //     ]
    // }
    // AllRoutes.addCompanyUserRoute
];

export const clinicSideMenu = [
    // AllRoutes.clinicRegisterModule,
    AllRoutes.profileClinicRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute,
    // AllRoutes.clinicWalkInModule,
    // AllRoutes.patientQueuePath,
    AllRoutes.clinicPendingPayments,
    AllRoutes.medicalCertificatesList,
    // AllRoutes.clinicRegisterNewPatient,
    AllRoutes.clinicStaffManagement,
    // AllRoutes.clinicCollectedPayments
    // AllRoutes.myEwalletApplicationRoute,
    {
        'name': 'Video Guides',
        'meta': {
            'title': 'Video Guides',
            'icon': 'fa-film'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.videoGuideClinicAdminPath,
            // AllRoutes.videoGuideClinicDoctorPath,
            AllRoutes.videoGuidePanelClinicDoctorConsultationGuideDetailed,
            AllRoutes.videoGuideClinicNursePath,
            AllRoutes.videoGuidePanelClinicCheckIn
        ]
    }
];

export const tpaSideMenu = [
    AllRoutes.tpaProfileModule,
    AllRoutes.tpaEnrolledCompaniesModule,
    AllRoutes.tpaInviteNewCompanyModule,
    AllRoutes.tpaCompanyInvitationReportModule
];

export const publicSideMenu = [];

export const clinicDoctorSideMenu = [
    AllRoutes.patientQueuePath,
    AllRoutes.medicalCertificatesList,
    AllRoutes.staffChangePassword,
    {
        'name': 'Video Guides',
        'meta': {
            'title': 'Video Guides',
            'icon': 'fa-film'
        },
        'parent': true,
        'expand': false,
        'childs': [
            // AllRoutes.videoGuideClinicDoctorPath,
            AllRoutes.videoGuidePanelClinicDoctorConsultationGuideDetailed,
            AllRoutes.videoGuidePanelClinicCheckIn
        ]
    }
];

export const clinicNurseSideMenu = [
    AllRoutes.clinicRegisterModule,
    // AllRoutes.clinicWalkInModule,
    AllRoutes.patientQueuePath,
    AllRoutes.clinicPendingPayments,
    AllRoutes.clinicRegisterNewPatient,
    AllRoutes.medicalCertificatesList,
    AllRoutes.staffChangePassword,
    {
        'name': 'Video Guides',
        'meta': {
            'title': 'Video Guides',
            'icon': 'fa-film'
        },
        'parent': true,
        'expand': false,
        'childs': [
            AllRoutes.videoGuideClinicNursePath,
            AllRoutes.videoGuidePanelClinicCheckIn
        ]
    }
];

export const vaccinationCentreSideMenu = [
    AllRoutes.vaccinationCentreDashboard,
    AllRoutes.vaccinationCentreProfile
];

export const optometristSideMenu = [
    AllRoutes.profileOptometristRoute,
    AllRoutes.changePasswordRoute,
    AllRoutes.changeEmailAddressRoute
];

let routes = Object.values(AllRoutes);
export default routes;

export const userSideMenus = {
    userSideMenu,
    superAdminSideMenu,
    iphAdminSideMenu,
    doctorSideMenu,
    pharmacyAdminSideMenu,
    pharmacyUserSideMenu,
    companyAdminSideMenu,
    publicSideMenu,
    clinicSideMenu,
    tpaSideMenu,
    clinicDoctorSideMenu,
    clinicNurseSideMenu,
    vaccinationCentreSideMenu,
    optometristSideMenu
};
